import React from 'react'
import { useLocation } from 'react-router-dom'
import { motion, useReducedMotion } from 'framer-motion'

/**
 * Eases page content in on section change. Keyed on the top-level route segment
 * (e.g. "/admin/clients"), so switching sections replays the enter animation
 * but sub-navigation inside a section does not re-trigger.
 *
 * Enter-only by design: keying the motion element remounts it on section change,
 * which avoids the AnimatePresence + React Router "exit shows the next route"
 * flicker. Pass `disabled` for full-screen routes (editor / preview). Collapses
 * to an instant swap under prefers-reduced-motion.
 */
export default function PageTransition({ children, disabled = false }) {
  const location = useLocation()
  const reduce = useReducedMotion()

  // "/admin/clients/123" -> "/admin/clients"
  const sectionKey = location.pathname.split('/').slice(0, 3).join('/')

  if (disabled || reduce) return <>{children}</>

  return (
    <motion.div
      key={sectionKey}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
      style={{ height: '100%' }}
    >
      {children}
    </motion.div>
  )
}
